/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="9.32"
        height="12.03"
        viewBox="0 0 9.32 12.03"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M9.11 11.03v1H.19v-1ZM5.17.03v7.78L8.6 4.36l.71.71-4.62 4.65L0 5.05l.7-.71 3.47 3.45V0Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'ArrowDownToLineIcon';

export default Icon;
